import React from 'react';
import { IconProps } from '../types';

const AddIcon = ({
  width = '22px',
  height = '21px',
  color = '#fff'
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={color}
      viewBox="0 0 20 20"
    >
      <title>add</title>
      <path d="M11 9V4H9v5H4v2h5v5h2v-5h5V9z" />
    </svg>
  );
};

export default AddIcon;
